module.exports = __webpack_public_path__ + "media/images/step-two-c1c8007c.svg";